:host {
  --size: 1em;
  --indicator-color: currentColor;
  --speed: 0.75s;

  flex: none;
  display: inline-flex;
  width: var(--size);
  height: var(--size);
  color: var(--indicator-color);
}

svg {
  width: 100%;
  height: 100%;
  fill: currentColor;
}

.spinner {
  transform-origin: center;
  animation: spin var(--speed) linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
